import { createExternalStore } from "@nova/toolkit-pure-hooks"
import { WeatherMode } from "features/map/control/types"

const EMPTY: number[] = []

const frameTimesStore = createExternalStore<number[], WeatherMode>()

const sameTimes = (a: number[], b: number[]) =>
    a.length === b.length && a.every((ms, i) => ms === b[i])

export const publishWeatherFrameTimes = (mode: WeatherMode, timesMs: number[]) => {
    if (sameTimes(frameTimesStore.getItem(mode) ?? EMPTY, timesMs)) return
    if (timesMs.length === 0) frameTimesStore.remove(mode)
    else frameTimesStore.set(mode, timesMs)
}

export const useWeatherFrameTimes = (mode: WeatherMode) => frameTimesStore.useItem(mode) ?? EMPTY
